// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27Sr2","left":"styles_left__3Yk75","desktopActions":"styles_desktopActions__3JhE9","title":"styles_title__1JFgs"};